import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { BillStatusType } from '../bills/bill-grid-components/bill-management-types';
import { BaseFilterProps, StatusFilterLabelText } from './filter-types';

export interface BillStatusFilterProps extends BaseFilterProps {
  onBillStatusChange?: (billStatus: BillStatusType) => void;
}

export const BillStatusFilter = ({
  control,
  errors,
  onBillStatusChange,
}: BillStatusFilterProps): JSX.Element => {
  const options = [
    { value: { held: true, submitted: false }, label: 'Held' },
    { value: { held: false, submitted: true }, label: 'Submitted' },
    {
      value: { held: false, submitted: false },
      label: 'Pending',
    },
  ];

  return (
    <Controller
      control={control}
      name="billStatus"
      render={({ field: { onChange, value } }): JSX.Element => {
        const selectedOption = options.find(
          option =>
            option.value.held === value.held &&
            option.value.submitted === value.submitted,
        );

        return (
          <Autocomplete
            id="bill-status-select"
            value={selectedOption}
            options={options}
            size="small"
            sx={{ minWidth: 230, maxWidth: 230 }}
            onChange={(_, newValue): void => {
              const billStatus = newValue?.value || {
                held: false,
                submitted: false,
              };
              onChange(billStatus);
              if (onBillStatusChange) {
                onBillStatusChange(billStatus);
              }
            }}
            getOptionLabel={(option): string => option.label}
            isOptionEqualToValue={(option, value): boolean =>
              option.value === value.value
            }
            renderInput={(params): JSX.Element => (
              <HHTextField
                {...params}
                required
                hhVariant="variant-bypass"
                variant="standard"
                label={StatusFilterLabelText.BILL_STATUS}
                error={Object.keys(errors?.billStatus ?? {}).length !== 0}
                helperText={errors.billStatus?.message as string}
              />
            )}
          />
        );
      }}
    />
  );
};
